import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import xss from 'xss';
import { useLazyLoadImage } from 'tmt-ui-kit';

import { path } from '~/utils/media';
import { stripLink } from '~/utils/helpers';

const ImageWrapper = styled.div`
  flex: 1;
`;

const Image = styled.img`
  width: 100%;
  transition: ${props => props.theme.imageTransition};
  opacity: 0;
`;

function renderImageColumn(img, alt) {
  const ref = useRef();
  useLazyLoadImage(ref);
  return (
    <ImageWrapper>
      <Image
        ref={ref}
        src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
        data-src={path(img, 'articleImage')}
        data-srcSet={`${path(img, 'articleImage2x')}`}
        alt={alt}
      />
    </ImageWrapper>
  );
}

const TextColumn = styled.div`
  line-height: 26px;
  flex: 1;
  ${props => {
    if (props.orientation === 'right') {
      return 'padding-left: 30px;';
    }
    return 'padding-right: 30px;';
  }}
  @media(max-width: 700px) {
    padding: 10px 0px !important;
  }
`;

const textLargeStyle = css `
  >p, >ul {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.8;
    @media (max-width: 700px) {
      font-size: 17px;  
    }
  }
  >h2 {
    font-size: 36px;
    font-weight: 500;
    @media (max-width: 700px) {
      font-size: 24px;
    }
  }
  >h3 {
    font-size: 30px;
    font-weight: 500;          
    @media (max-width: 700px) {
      font-size: 22px;
    }
  }
  >h4 {
    font-size: 24px;
    font-weight: 500;          
    @media (max-width: 700px) {
      font-size: 19px;
    }
  }
`;

const textSmallStyle = css `
  >h2 {
    font-size: 24px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 20px;
    }
  }
  >h3 {
    font-size: 20px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 18px;
    }
  }
  >h4 {
    font-size: 18px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 16px;
    }
  } 
`;

const Text = styled.div`
  > p {
    font-weight: 400;
  }
  ${props => (props.large ? textLargeStyle : textSmallStyle)}
`;

function renderTextColumn(text, orientation, large, fullPath) {
  return (
    <TextColumn orientation={orientation}>
      <Text
        large={large}
        dangerouslySetInnerHTML={{ __html: xss(fullPath ? stripLink(text, fullPath) : text) }}
      />
    </TextColumn>
  );
}

const ImageAndTextContainer = styled.div`
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  align-items: center;
  flex-direction: ${props => (props.orientation === 'left-right' ? 'row' : 'row-reverse')};
  @media(max-width: 700px) {
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    flex-direction: column !important;
  }
`;

const ImageAndTextTopic = (props) => {
  const { large, fullPath } = props;
  const { image, text, orientation, img_alt: imgAlt = '' } = props.data;
  return (
    <ImageAndTextContainer orientation={orientation}>
      {renderImageColumn(image, imgAlt)}
      {renderTextColumn(text, orientation === 'left-right' ? 'right' : 'left', large, fullPath)}
    </ImageAndTextContainer>
  );
};

ImageAndTextTopic.propTypes = {
  large: PropTypes.bool,
  fullPath: PropTypes.string,
  data: PropTypes.object
};

export default ImageAndTextTopic;
